/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Scheduled_Sync_SuccessInputs */



/**
* | output |
* | --- |
* | "Automatic sync updated." |
*
* @param {Spaces_Scheduled_Sync_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_success = /** @type {((inputs?: Spaces_Scheduled_Sync_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Synchronisierung aktualisiert.")
	return /** @type {LocalizedString} */ ("Automatic sync updated.")
});